<template>
  <div class="sc-message--location" :style="colors[message.direction || 'received']" ref="iframe">
    <iframe
      v-if="isSeen"
      loading="lazy"
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      :src="openStreetMapUrl"
      class="sc-message-map"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  name: "GeolocationMessage",
  inject: {
    widget: {
      type: Object
    },
    colors: {
      type: Object
    }
  },
  mounted () {
    this.observer.observe(this.$refs.iframe);
  },
  props: {
    message: {
      type: Object,
      required: true,
      default() {
        return {
          data: {
            coordinates: {
              lat: 0.0,
              lng: 0.0
            }
          }
        }
      }
    }
  },
  data () {
    return {
      isSeen: false,
      observer: new IntersectionObserver(entries => {
        !this.isSeen && entries[0].intersectionRatio > 0 && (this.isSeen = true)
      })
    }
  },
  watch: {
    isSeen (isSeen) {
      if (isSeen && this.widget.scroll > 85) {
        this.widget.scroll = 101;
      }
    }
  },
  computed: {
    coordinates() {
      return (this.message.data && this.message.data.coordinates) || { lat: 0.0, lng: 0.0 }
    },
    openStreetMapUrl() {
      return (
        'https://www.openstreetmap.org/export/embed.html?bbox=' +
        (this.coordinates.lng - 0.1) +
        ',' +
        (this.coordinates.lat - 0.1) +
        ',' +
        (this.coordinates.lng + 0.1) +
        ',' +
        (this.coordinates.lat + 0.1) +
        '&layer=mapnik&marker=' +
        this.coordinates.lat +
        ',' +
        this.coordinates.lng
      )
    }
  }
}
</script>

<style scoped>
.sc-message--location {
  border-radius: 6px;
}
.sc-message-map {
  width: 200px;
  height: 150px;
  border-radius: 6px;
}
</style>
